module.exports = __webpack_public_path__ + "static/media/glass-champagne.51859570.svg";